import { Typography } from '@mui/material'
// helper
import { getLinkText } from '$func/link'

export function linkParser(key: string, result: string[]) {
  const link = getLinkText(result[0])
  return (
    <Typography key={key} variant="paragraph3" color="white" dir="ltr">
      {link}
    </Typography>
  )
}
